import React, { useEffect, useState } from "react";
import * as Fa from "react-icons/fa";
// import { RadioButton } from "primereact/radiobutton";
// import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Link, useSearchParams } from "react-router-dom";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import Axios from "../../api/Axios";
import { AutoComplete } from "primereact/autocomplete";
import Loader from "../../Components/Loader";
import { InputTextarea } from "primereact/inputtextarea";
import { toast } from "react-toastify";
import storage from "../../Services/Storage";
import CommentsPopUp from "./CommentsPopUp";

const FocUnlockRequestAddNew = () => {
    const [partynamesugg, setPartynamesugg] = useState([]);
    const [onchangepartyname, setOnchangepartyname] = useState(null);
    const [partyname, setPartyname] = useState([]);
    const [selectedQrm, setSelectedQrm] = useState([]);
    const [distComments, setDistComments] = useState("");
    const [statusQrm, setStatusQrm] = useState();
    const [qrmNo, setQrmNo] = useState();
    const [getQrmdata, setGetQrmdata] = useState([]);
    const [date, setDate] = useState(new Date());
    const [loading, setLoading] = useState(false);
    const [loadingdt, setLoadingdt] = useState(false);
    const [onView, setOnView] = useState(false);
    const [docdate, setDocdate] = useState();
    const [custname, setCustname] = useState("");

    const [visible, setVisible] = useState(false);
    const [onsaveView, setOnsaveView] = useState(false);
    const [asmComments, setAsmComments] = useState("");
    const [rsmComments, setRsmComments] = useState("");
    const [csmComments, setCsmComments] = useState("");

    const [searchparam] = useSearchParams();
    let qrmId = searchparam.get("qrmHdrId");
    const auth = storage.getLocal("user");
    useEffect(() => {
        const onPageLoad = async () => {
            // /api/FocUnlock/getcustomer
            try {
                setLoading(true);
                const cnFocurl = "QRM_CN/GetCustomer?";
                const cnFocCustData = `${cnFocurl}above180=Y&cn_tag=N&compid=${auth.CompId}`;
                let dataresponse = await Axios.get(cnFocCustData);
                if (dataresponse.data.Data != 0) {
                    setPartynamesugg(dataresponse.data.Data);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };
        if (qrmId) {
            setOnView(true);
            onViewPage(qrmId);
            onCommentsView(qrmId);
        } else {
            onPageLoad();
        }
    }, []);

    const onViewPage = async (qrmIdno) => {
        try {
            setLoadingdt(true);
            const cnFocQrmurl = "QRM_CN/GetApprovalByQrmNo?";
            const cnFocQrmData = `${cnFocQrmurl}QRM_ID=${qrmIdno}`;
            let dataresponse = await Axios.get(cnFocQrmData);
            setStatusQrm(dataresponse.data.Data[0].QRM_STATUS);
            setQrmNo(dataresponse.data.Data[0].QRM_H_ID);
            setDistComments(dataresponse.data.Data[0].DB_REASON);
            setCustname(dataresponse.data.Data[0].PARTY_NAME);
            setGetQrmdata(dataresponse.data.Data);
            setDocdate(new Date(formatDate(dataresponse.data.Data[0].REQ_DATE)));
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingdt(false);
        }
    };
    const onCommentsView = async (qrmIdno) => {
        try {
            setLoadingdt(true);
            const cnFocQrmurl = "QRM_CN/GetCommnetsByQrmNo?";
            const cnFocQrmData = `${cnFocQrmurl}qrmid=${qrmIdno}`;
            let dataresponse = await Axios.get(cnFocQrmData);
            setAsmComments(dataresponse.data.Data[0].ASM_REASON);
            setRsmComments(dataresponse.data.Data[0].RSM_REASON);
            setCsmComments(dataresponse.data.Data[0].CSM_REASON);
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingdt(false);
        }
    };

    const formatDate = (datestring) => {
        let [day, month, year] = datestring.toString().split("/");
        return `${month}/${day}/${year}`;
    };

    const searchEmployee = (e) => {
        setTimeout(() => {
            let _filteredemployee;
            if (!e.query.trim().length) {
                _filteredemployee = [...partynamesugg];
            } else {
                _filteredemployee = partynamesugg.filter((employee) => {
                    return employee.PARTY_NAME.toLowerCase().includes(
                        e.query.toLowerCase()
                    );
                });
            }

            setPartyname(_filteredemployee);
        }, 400);
    };

    const employeeTemplate = (employee) => {
        return <>{employee.PARTY_NAME}</>;
    };

    const onpartyChnge = (e) => {
        setOnchangepartyname(e?.target?.value);
        if (e?.target?.value?.PARTY_NAME) {
            getQrmData(e.target.value);
        } else {
            setGetQrmdata([]);
        }
    };

    const getQrmData = async (custID) => {
        try {
            setLoadingdt(true);
            const cnFocQrmurl = "QRM_CN/GetQRMData?";
            const cnFocQrmData = `${cnFocQrmurl}above180=Y&partyId=${encodeURIComponent(custID.PARTY_ID)}&cn_tag=N`;
            let dataresponse = await Axios.get(cnFocQrmData);
            setGetQrmdata(dataresponse.data.Data);
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingdt(false);
        }
    };

    const saveQRMData = async () => {
        if (!onchangepartyname) {
            toast.warn("Please Select the Customer Code from the dropdown", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        } else if (distComments.trim().length == 0) {
            toast.warn("Reason cannot be blank", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        } else if (selectedQrm.length == 0) {
            toast.warn("Please select a record to proceed", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        } else {
            let qrmList = selectedQrm.map((item) => {
                return {
                    pvcdocumenT_NO: "",
                    pvcdocumenT_DATE: "",
                    pvcschemE_CODE: item.SCHEME_CODE,
                    pvcschemE_NAME: item.SCHEME_NAME,
                    pvctotaL_VALUE: "0",
                    pvcoutstandinG_VALUE: "0",
                    pvcfoC_QUANTITY: item.QUANTITY.toString(),
                    pvcdatE_FREEZE: item.DATE_FREEZE,
                };
            });

            let qrmPayload = {
                pvcpartY_ID: onchangepartyname?.PARTY_ID,
                pvcabovE_180: "Y",
                pvcdB_REASON: distComments.toString().trim(),
                pvccN_TAG: "N",
                pvcuseR_ID: auth.UserId,
                selectedRecords: qrmList,
            };
            callingPostApi(qrmPayload);
        }
    };

    const callingPostApi = async (qrmPayload) => {
        try {
            setLoadingdt(true);
            let postURL = "QRM_CN/SaveQRMData?";
            let dataresponse = await Axios.post(postURL, JSON.stringify(qrmPayload), {
                headers: { "Content-Type": "application/json" },
            });
            setQrmNo(dataresponse.data.HDRID);
            setStatusQrm(dataresponse.data.Status);
            setOnsaveView(true);
            toast.success("Data saved successfully", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingdt(false);
        }
    };

    const stateprops = {
        visible,
        setVisible,
        asmComments,
        rsmComments,
        csmComments,
    };

    if (loading) {
        return <Loader />;
    } else {
        return (
            <>
                <div className="col-12 pt-3 pb-3">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mx-1">
                                    <li className="breadcrumb-item">
                                        <Link to="/qrm/FocUnlockRequestAll">
                                        FOC Unlock
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Details
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="float-end mb-2">
                                <Link to="/qrm/FocUnlockRequestAll">
                                    <button
                                        type="submit"
                                        className="btn btn-outline-primary me-3"
                                        title="Back to all Records"
                                    >
                                        <Fa.FaLongArrowAltLeft className="backIcon" /> Back to all
                                        Records
                                    </button>
                                </Link>
                                {!onView && <button
                                    type="button"
                                    title="Save"
                                    className="btn btn-primary"
                                    onClick={saveQRMData}
                                    disabled={onsaveView}
                                >
                                    Save
                                </button>}
                            </div>
                        </div>
                    </div>
                    <section className="sales-box">
                        <form>
                            <div className="row">
                                <div className="col-lg-4 col-md-4 col-sm-12 mb-3">
                                    <label className="form-label">QRM No.</label>
                                    <InputText
                                        className="form-control"
                                        type="text"
                                        value={qrmNo}
                                        disabled
                                    />
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-12 mb-3">
                                    <label className="form-label">Date</label>
                                    <Calendar
                                        value={onView ? docdate : date}
                                        onChange={(e) => setDate(e.value)}
                                        showIcon
                                        min="2010-01-01"
                                        dateFormat="dd/mm/yy"
                                        showMinMaxRange={true}
                                        disabled
                                    />
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-12 mb-3">
                                    <label className="form-label">Status</label>
                                    <InputText
                                        className="form-control"
                                        type="text"
                                        value={statusQrm}
                                        disabled
                                    />
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                                    <label className="form-label">Customer Name</label>
                                    {onView ? (
                                        <InputText
                                            className="form-control"
                                            type="text"
                                            value={custname}
                                            disabled
                                        />
                                    ) : (
                                        <AutoComplete
                                            field="PARTY_NAME"
                                            value={onchangepartyname}
                                            suggestions={partyname}
                                            completeMethod={searchEmployee}
                                            onChange={(e) => {
                                                onpartyChnge(e);
                                            }}
                                            dropdown={true}
                                            forceSelection
                                            itemTemplate={employeeTemplate}
                                            emptyMessage="No Customer found."
                                            showEmptyMessage
                                            disabled={onsaveView}
                                        />
                                    )}
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                                    <label className="form-label">
                                        Distributor&apos;s Comment
                                    </label>
                                    <InputTextarea
                                        className="form-control"
                                        type="text"
                                        value={distComments}
                                        // keyfilter="alphanum"
                                        onChange={(e) => setDistComments(e.target.value)}
                                        maxLength={200}
                                        disabled={onView || onsaveView}
                                    />
                                    <small className="p-error mt-2 text-end">
                                        Character left : {200 - distComments.length}
                                    </small>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="text-end">
                                        {onView && <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={() => setVisible(true)}
                                        >
                                            View comments
                                        </button>}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </section>
                    <section className="mb-3">
                        <h3 className="py-2">Records</h3>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            {loadingdt ? (
                                <>
                                    <Loader />
                                </>
                            ) : (
                                <div className="DataTable">
                                    <DataTable
                                        value={getQrmdata}
                                        rows={10}
                                        filterDisplay="row"
                                        // showGridlines
                                        stripedRows
                                        selectionMode="checkbox"
                                        scrollHeight="80vh"
                                        scrollable
                                        disabled
                                        selectAll={false}
                                        selection={selectedQrm}
                                        onSelectionChange={(e) => {
                                            setSelectedQrm(e.value);
                                        }}
                                        showSelectAll={false}
                                    >
                                        {!onView && <Column
                                            selectionMode="multiple"
                                            headerStyle={{ width: "5rem" }}
                                            header="Select All"
                                        ></Column>}
                                        <Column
                                            field="CUST_CODE"
                                            header="Code"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column
                                            field={onView ? "PARTY_NAME" : "CUST_NAME"}
                                            header="Name"
                                            headerStyle={{ width: "14rem" }}
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column
                                            field="SCHEME_CODE"
                                            header="Scheme Code"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column
                                            field="SCHEME_NAME"
                                            header="Scheme Description"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        ></Column>
                                        <Column field={onView ? "FOC_QUANTITY" : "QUANTITY"} header="Quantity"></Column>
                                        <Column field="DATE_FREEZE" header="Freeze Date"></Column>
                                    </DataTable>
                                </div>
                            )}
                        </div>
                    </section>
                </div>
                <CommentsPopUp stateprops={stateprops} />
            </>
        );
    }
};

export default FocUnlockRequestAddNew;
